import React from 'react';

import { Avatar, AvatarSize } from '../../../../components/Avatar/Avatar';
import { GQLFollowButton } from '../../../../components/Clickables/Buttons/GQLFollowButton';
import { InternalLink } from '../../../../components/Clickables/InternalLink/InternalLink';
import { Heading } from '../../../../components/Heading/Heading';
import { abbreviateNumber } from '../../../../helpers/numbers/abbreviateNumber';
import { getCoverImage } from '../../../../helpers/page';
import { getPageUrl } from '../../../../helpers/urls';
import {
  GetDiscoveredBrands_entry_edges_node,
  FollowRecordsTypeEnum,
} from '../../../../interfaces/graphql';

interface IProps {
  brand: GetDiscoveredBrands_entry_edges_node;
}

export const BrandCard = ({ brand }: IProps) => {
  const { _id, logo, displayName, followedByCurrentUser, followers, coverImages } = brand;
  const coverImage = getCoverImage(coverImages);
  return (
    <div
      style={{
        background: `linear-gradient(rgba(0,0,0,0),rgba(0,0,0,8)), center / cover no-repeat url("${coverImage}")`,
        minWidth: 200,
        minHeight: 180,
        marginRight: '8px',
      }}
    >
      <InternalLink to={getPageUrl(_id, displayName)} variant="textPrimaryDarkBg">
        <div className="flex h-36 flex-col items-center">
          <div className="self-start p-2">
            {logo && logo.url && (
              <Avatar alt={displayName} src={logo.url} size={AvatarSize.SMALL} />
            )}
          </div>
          <Heading
            variant="2xs"
            as="h3"
            color="light"
            className="mt-auto truncate text-center"
            title={displayName}
          >
            {displayName}
          </Heading>
          <div className="body-text-sm mb-2 text-white">
            Followed by {abbreviateNumber(followers.totalCount)} anglers
          </div>
        </div>
      </InternalLink>
      <GQLFollowButton
        source="brand-follow-button"
        isFollowed={followedByCurrentUser}
        id={brand._id}
        type={FollowRecordsTypeEnum.PAGE}
        buttonProps={{ className: 'w-full', style: { borderRadius: 0 } }}
        customAppDownloadHeader={`Download the Fishbrain app to follow ${displayName}`}
      />
    </div>
  );
};
